import { constants } from "@newsela/angelou";

import { VideoSubject } from "@/view/GeniusContent/GeniusContent.interface";
import { componentConfigError, locationConfigError } from "./errorMessages";
import propConfigMap from "./propConfigMap";

import type { ComponentPropsMap } from "./propConfigMap";

export function getPropsFor<C extends keyof ComponentPropsMap>(
  location: string,
  component: C,
  subject?: string | null | undefined,
): ComponentPropsMap[C] {
  const locationConfig = propConfigMap.get(location);
  if (!locationConfig) return locationConfigError();

  const componentProps = locationConfig[component];
  if (!componentProps) return componentConfigError();

  // These customizations should apply only to Generation Genius.
  if (subject && component === "NoAccessBanner") {
    const props = componentProps as ComponentPropsMap[C];

    let backgroundColor = "";
    if (subject === VideoSubject.LANGUAGE_ARTS) {
      backgroundColor = constants.colors.product.ela["50"];
    } else if (subject === VideoSubject.MATHEMATICS) {
      backgroundColor = constants.colors.ui.teal["100"];
    } else if (subject === VideoSubject.SCIENCE) {
      backgroundColor = constants.colors.product.science["50"];
    } else {
      // Fallback for unexpected subjects
      backgroundColor = constants.colors.ui.core["50"];
    }

    return {
      ...props,
      __cssFor: {
        ...props.__cssFor,
        root: {
          backgroundColor,
          "> div": { gap: "20px" },
        },
      },
    };
  }

  return componentProps;
}
